import React from "react";
import { injectIntl } from "react-intl";
import { Timeline as AntdTimeline } from "antd";
import { CheckOutlined, ClockCircleOutlined } from "@ant-design/icons";
import {
  INGRESSO_BLOCCO_OPERATORIO,
  INGRESSO_SALA_OPERATORIA,
  USCITA_SALA_OPERATORIA,
  USCITA_BLOCCO_OPERATORIO,
} from "../../../modules/surgery";
import {
  INGRESSO_BLOCCO_OPERATORIO_LABEL,
  INGRESSO_SALA_OPERATORIA_LABEL,
  USCITA_SALA_OPERATORIA_LABEL,
  USCITA_BLOCCO_OPERATORIO_LABEL,
} from "../../../modules/language";
import { getMessageString } from "../../../tools";
import { StatoOperazione } from "./StatoOperazione";

const { Item } = AntdTimeline;

const TimelineBase = ({ info, intl }) => {
  // const TimelineBase = ({ intl }) => {
  // const info = {
  //   ingressoBloccoOperatorio: "11:34",
  //   ingressoSalaOperatoria: "12:34",
  //   uscitaSalaOperatoria: "02:34",
  //   uscitaBloccoOperatorio: "03:34",
  // };
  return (
    <AntdTimeline mode="right">
      <Item
        {...(info[INGRESSO_BLOCCO_OPERATORIO] &&
          info[INGRESSO_BLOCCO_OPERATORIO] !== undefined && {
            //prettier-ignore
            ...(((info[INGRESSO_SALA_OPERATORIA] && info[INGRESSO_SALA_OPERATORIA] !== undefined) || (info[USCITA_BLOCCO_OPERATORIO] && info[USCITA_BLOCCO_OPERATORIO] !== undefined)) && {
              dot: <CheckOutlined />,
              label: info[INGRESSO_BLOCCO_OPERATORIO],
            }),
            //prettier-ignore
            ...((!info[INGRESSO_SALA_OPERATORIA] || info[INGRESSO_SALA_OPERATORIA] === undefined) && (!info[USCITA_BLOCCO_OPERATORIO] || info[USCITA_BLOCCO_OPERATORIO] === undefined) && {
              className: "eventoInCorso",
              dot: <ClockCircleOutlined />,
              label: (
                <div className="infoConStato">
                  {info[INGRESSO_BLOCCO_OPERATORIO]}
                  {(!info[USCITA_SALA_OPERATORIA] || info[USCITA_SALA_OPERATORIA] === undefined) && <StatoOperazione info={info} />}
                </div>
              ),
            }),
          })}
        {...((!info[INGRESSO_BLOCCO_OPERATORIO] || info[INGRESSO_BLOCCO_OPERATORIO] === undefined) &&
          (!info[INGRESSO_SALA_OPERATORIA] || info[INGRESSO_SALA_OPERATORIA] === undefined) &&
          (!info[USCITA_SALA_OPERATORIA] || info[USCITA_SALA_OPERATORIA] === undefined) &&
          (!info[USCITA_BLOCCO_OPERATORIO] || info[USCITA_BLOCCO_OPERATORIO] === undefined) && {
            label: (
              <div className="interventoPianificato">
                <StatoOperazione info={info} />
              </div>
            ),
          })}
      >
        {getMessageString(intl, INGRESSO_BLOCCO_OPERATORIO_LABEL)}
      </Item>
      <Item
        {...(info[INGRESSO_SALA_OPERATORIA] &&
          info[INGRESSO_SALA_OPERATORIA] !== undefined && {
            ...(info[USCITA_SALA_OPERATORIA] && info[USCITA_SALA_OPERATORIA] !== undefined && { dot: <CheckOutlined />, label: info[INGRESSO_SALA_OPERATORIA] }), //prettier-ignore
            ...((!info[USCITA_SALA_OPERATORIA] || info[USCITA_SALA_OPERATORIA] === undefined) && {
              className: "eventoInCorso",
              dot: <ClockCircleOutlined />,
              label: (
                <div className="infoConStato">
                  {info[INGRESSO_SALA_OPERATORIA]}
                  <StatoOperazione info={info} />
                </div>
              ),
            }),
          })}
      >
        {getMessageString(intl, INGRESSO_SALA_OPERATORIA_LABEL)}
      </Item>
      <Item
        {...(info[USCITA_SALA_OPERATORIA] &&
          info[USCITA_SALA_OPERATORIA] !== undefined && {
            className: (!info[USCITA_BLOCCO_OPERATORIO] || info[USCITA_BLOCCO_OPERATORIO] === undefined) ? "eventoInCorso" : "",
            dot: <CheckOutlined />,
            label: (
              <div className="infoConStato">
                {info[USCITA_SALA_OPERATORIA]}
                {(!info[USCITA_BLOCCO_OPERATORIO] || info[USCITA_BLOCCO_OPERATORIO] === undefined) && (
                  <StatoOperazione info={info} />
                )}
              </div>
            ),
          })}
      >
        {getMessageString(intl, USCITA_SALA_OPERATORIA_LABEL)}
      </Item>
      <Item
        {...(info[USCITA_BLOCCO_OPERATORIO] &&
          info[USCITA_BLOCCO_OPERATORIO] !== undefined && {
            className: "eventoInCorso",
            dot: <CheckOutlined />,
            label: (
              <div className="infoConStato">
                {info[USCITA_BLOCCO_OPERATORIO]}
                <StatoOperazione info={info} />
              </div>
            ),
          })}
      >
        {getMessageString(intl, USCITA_BLOCCO_OPERATORIO_LABEL)}
      </Item>
    </AntdTimeline>
  );
};

export const Timeline = injectIntl(TimelineBase);
